"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateProfileSchema = exports.UpdateUserBankingDetailsSchema = void 0;
const cpf_1 = require("./helpers/cpf");
const Yup = __importStar(require("yup"));
const cnpj_1 = require("./helpers/cnpj");
const REQUIRED_FIELD = 'Este campo é obrigatório';
exports.UpdateUserBankingDetailsSchema = Yup.object({
    pix_type: Yup
        .string()
        .oneOf(['EMAIL', 'PHONE_NUMBER', 'CPF', 'RANDOM_KEY', 'CNPJ'])
        .required(REQUIRED_FIELD),
    pix_key: Yup.string().when('pix_type', ([pix_type], schema) => {
        if (pix_type === 'CPF') {
            return schema.test({
                test: cpf_1.CPF_TEST,
                message: 'Deve ser um CPF válido',
            });
        }
        if (pix_type === 'CNPJ') {
            return schema.test({
                test: cnpj_1.CNPJ_TEST,
                message: 'Deve ser um CNPJ válido',
            });
        }
        if (pix_type === 'EMAIL') {
            return schema.email('Deve ser um e-mail válido');
        }
        if (pix_type === 'RANDOM_KEY') {
            return schema.length(32, 'Deve conter 32 caracteres');
        }
        if (pix_type === 'PHONE_NUMBER') {
            return schema.test({
                test: (value) => {
                    const clean = value === null || value === void 0 ? void 0 : value.replace(/\D/ig, '');
                    if ((clean === null || clean === void 0 ? void 0 : clean.length) === 9) {
                        return true;
                    }
                    return false;
                },
                message: 'Deve conter 9 números'
            });
        }
        return schema;
    })
        .required(REQUIRED_FIELD),
});
exports.UpdateProfileSchema = Yup.object({
    telegram: Yup.string().required(REQUIRED_FIELD),
    cep: Yup.string().test({
        message: 'Deve ser um CEP válido',
        test: (value) => {
            const cep = value === null || value === void 0 ? void 0 : value.replace(/\D/ig, '');
            return (cep === null || cep === void 0 ? void 0 : cep.length) === 8;
        }
    }).required(REQUIRED_FIELD),
    address_street: Yup.string().required(REQUIRED_FIELD),
    address_number: Yup.string().required(REQUIRED_FIELD),
    phone_number: Yup.string().required(REQUIRED_FIELD),
    whatsapp: Yup.string().required(REQUIRED_FIELD),
    complement: Yup.string().optional(),
    city: Yup.string().required(REQUIRED_FIELD),
    state: Yup.string().length(2, 'Use apenas a sigla do estado (Ex.: SP, RJ, SC)').required(REQUIRED_FIELD),
    password: Yup.string().test((value, schema) => {
        if (!value) {
            return true;
        }
        if ((value === null || value === void 0 ? void 0 : value.length) < 8) {
            return schema.createError({
                message: 'Deve conter no mínimo 8 caracteres'
            });
        }
        if (!(value === null || value === void 0 ? void 0 : value.match(/[a-z]+/))) {
            return schema.createError({
                message: 'Deve conter no mínimo uma letra minúscula'
            });
        }
        if (!(value === null || value === void 0 ? void 0 : value.match(/[A-Z]+/))) {
            return schema.createError({
                message: 'Deve conter no mínimo uma letra maiúscula'
            });
        }
        if (!(value === null || value === void 0 ? void 0 : value.match(/\d+/))) {
            return schema.createError({
                message: 'Deve conter um número'
            });
        }
        return true;
    }),
    password_confirmation: Yup.string().oneOf([Yup.ref('password')], 'As senhas devem ser iguais').when('password', ([value], schema) => {
        if (!!value) {
            return schema.required(REQUIRED_FIELD);
        }
        return schema;
    }),
    neighborhood: Yup.string().required(REQUIRED_FIELD),
});
